const _excluded = ["inputService", "label", "placeholderFrom", "placeholderTo", "formatDate", "usingDateTime", "allowClear"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { getJsonSchemaDate, getJsonSchemaDateTime, getLocalDate } from 'buzz_lib_shared';
import { useInput } from '../../../machines/inputMachine/useInput';
import { DatePicker } from '../../DatePicker';
import { Icon } from '../../Icons';
import { Label } from '../../Label';
import { Stack } from '../../Stack';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { defaultDateFormatter } from '../DatePickerControl/defaultDateFormatter';
import { SharedClearButton } from '../SharedClearButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateRangeControl = _ref => {
  let {
      inputService,
      label,
      placeholderFrom,
      placeholderTo,
      formatDate = defaultDateFormatter,
      usingDateTime = false,
      allowClear
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!inputService) return /*#__PURE__*/_jsx("div", {
    children: "No input service defined"
  });
  const {
    name,
    value,
    errorMessage,
    send,
    touched
  } = useInput(inputService);
  const handleBlur = () => {
    send([{
      type: 'BLUR'
    }, {
      type: 'COMMIT'
    }]);
  };
  const handleFocus = () => {
    send({
      type: 'FOCUS'
    });
  };
  const handleChange = newValue => {
    send([{
      type: 'CHANGE',
      value: newValue
    }, {
      type: 'COMMIT'
    }]);
  };
  const renderTextFiledSuffix = props => /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    iconName: "Calendar",
    styles: {
      root: {
        cursor: props !== null && props !== void 0 && props.disabled ? 'inherit' : 'pointer',
        fontSize: 16
      }
    },
    onClick: event => {
      (props === null || props === void 0 ? void 0 : props.onClick) && props.onClick(event);
      send([{
        type: 'FOCUS'
      }, {
        type: 'BLUR'
      }]);
    }
  }));
  const textFieldProps = {
    styles: {
      suffix: {
        background: !props.disabled ? 'transparent' : 'none rgb(244, 244, 244)'
      }
    },
    iconProps: {
      styles: {
        root: {
          display: 'none'
        }
      }
    },
    onRenderSuffix: renderTextFiledSuffix
  };
  return /*#__PURE__*/_jsxs(Stack, {
    tokens: {
      childrenGap: 5
    },
    children: [/*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      horizontalAlign: "start",
      grow: true,
      tokens: {
        childrenGap: 10
      },
      children: [/*#__PURE__*/_jsxs(Stack, {
        children: [/*#__PURE__*/_jsx(Stack.Item, {
          children: /*#__PURE__*/_jsxs(Label, {
            children: [label !== null && label !== void 0 ? label : name, " From"]
          })
        }), /*#__PURE__*/_jsx(Stack.Item, {
          children: /*#__PURE__*/_jsx(DatePicker, _objectSpread(_objectSpread({}, props), {}, {
            value: getLocalDate(value === null || value === void 0 ? void 0 : value.From),
            placeholder: placeholderFrom,
            onSelectDate: date => {
              if (date) {
                const newDate = usingDateTime ? getJsonSchemaDateTime(date) : getJsonSchemaDate(date);
                handleChange(_objectSpread(_objectSpread({}, value), {}, {
                  From: newDate
                }));
              }
            },
            formatDate: formatDate,
            onBlur: handleBlur,
            onFocus: handleFocus,
            textField: textFieldProps
          }))
        })]
      }), /*#__PURE__*/_jsxs(Stack, {
        children: [/*#__PURE__*/_jsx(Stack.Item, {
          children: /*#__PURE__*/_jsxs(Stack, {
            horizontal: true,
            horizontalAlign: "space-between",
            grow: true,
            children: [/*#__PURE__*/_jsx(Stack.Item, {
              align: "start",
              children: /*#__PURE__*/_jsxs(Label, {
                children: [label !== null && label !== void 0 ? label : name, " To"]
              })
            }), allowClear && /*#__PURE__*/_jsx(Stack.Item, {
              align: "end",
              children: /*#__PURE__*/_jsx(SharedClearButton, {
                simple: allowClear === 'simple',
                send: send
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Stack.Item, {
          children: /*#__PURE__*/_jsx(DatePicker, _objectSpread(_objectSpread({}, props), {}, {
            value: getLocalDate(value === null || value === void 0 ? void 0 : value.To),
            placeholder: placeholderFrom,
            onSelectDate: date => {
              if (date) {
                const newDate = usingDateTime ? getJsonSchemaDateTime(date) : getJsonSchemaDate(date);
                handleChange(_objectSpread(_objectSpread({}, value), {}, {
                  To: newDate
                }));
              }
            },
            formatDate: formatDate,
            onBlur: handleBlur,
            onFocus: handleFocus,
            textField: textFieldProps
          }))
        })]
      })]
    }), /*#__PURE__*/_jsx(Stack, {
      children: errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
        children: error
      }, "error".concat(index)))
    })]
  });
};